<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part">Part I Preparing Your 90/10 Kitchen</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983969_epub_p01_r1.vue?7fdba825